
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","fill":"white"}},[_c('ellipse',{attrs:{"cx":"12.294","cy":"17","rx":"1.68","ry":"1.68"}})]),_c('ellipse',{attrs:{"cx":"12.294","cy":"17","rx":"1.68","ry":"1.68","fill":"currentColor"}}),_c('path',{attrs:{"d":"m11.974 17c0-0.1768 0.1432-0.32 0.32-0.32v4c2.0324 0 3.68-1.6476 3.68-3.68h-4zm0.32-0.32c0.1767 0 0.32 0.1432 0.32 0.32h-4c0 2.0324 1.6476 3.68 3.68 3.68v-4zm0.32 0.32c0 0.1767-0.1433 0.32-0.32 0.32v-4c-2.0324 0-3.68 1.6476-3.68 3.68h4zm-0.32 0.32c-0.1768 0-0.32-0.1433-0.32-0.32h4c0-2.0324-1.6476-3.68-3.68-3.68v4z","fill":"none","mask":"url(#a)"}}),_c('path',{attrs:{"d":"m8.2274 12.933c-0.39052 0.3905-0.39052 1.0237 0 1.4142 0.39053 0.3906 1.0237 0.3906 1.4142 0l-1.4142-1.4142zm6.72 1.4142c0.3905 0.3906 1.0237 0.3906 1.4142 0 0.3905-0.3905 0.3905-1.0237 0-1.4142l-1.4142 1.4142zm-9.2404-3.9343c-0.39053 0.3906-0.39053 1.0237 0 1.4143 0.39052 0.3905 1.0237 0.3905 1.4142 0l-1.4142-1.4143zm11.76 1.4143c0.3905 0.3905 1.0237 0.3905 1.4142 0 0.3905-0.3906 0.3905-1.0237 0-1.4143l-1.4142 1.4143zm-14.28-3.9342c-0.39052 0.39053-0.39052 1.0237 0 1.4142 0.39053 0.39052 1.0237 0.39052 1.4142 0l-1.4142-1.4142zm16.8 1.4142c0.3906 0.39052 1.0237 0.39052 1.4142 0 0.3906-0.39053 0.3906-1.0237 0-1.4142l-1.4142 1.4142zm-10.346 5.04c1.4652-1.4651 3.8406-1.4651 5.3058 0l1.4142-1.4142c-2.2462-2.2462-5.888-2.2462-8.1342 0l1.4142 1.4142zm-2.5205-2.52c2.8569-2.857 7.4889-2.857 10.346 0l1.4142-1.4143c-3.638-3.6379-9.5363-3.6379-13.174 0l1.4142 1.4143zm-2.5195-2.52c4.2487-4.2487 11.137-4.2487 15.386 0l1.4142-1.4142c-5.0297-5.0297-13.184-5.0297-18.214 0l1.4142 1.4142z","fill":"currentColor"}})])
          )
        }
      }
    